import { salesUser, demoSMTP, demoPopularLocations, demoUser, demoListings, demoProfiles } from './demo';
import showToaster from '../toasterMessages/showToaster';
import { getConfigData } from "../getConfigData";

export function demoRestriction({ restrictType = null, restrictValue = null }) {
	return async (dispatch, getState, { client }) => {
		try {
			const settingData = await getConfigData({ name: ['isDemoRestricted'] });
			const adminId = getState()?.account?.privileges?.id;
			if (settingData?.isDemoRestricted == "true") {
				switch (restrictType) {

					case 'SMTP':
						if (salesUser.indexOf(adminId) < 0 && demoSMTP.indexOf(restrictValue) > -1) {
							showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
							return true;
						} else return false;

					case 'popularLocation':
						if (salesUser.indexOf(adminId) < 0 && demoPopularLocations.indexOf(restrictValue) > -1) {
							showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
							return true;
						} else return false;

					case 'user':
						if (salesUser.indexOf(adminId) < 0 && demoUser.indexOf(restrictValue) > -1) {
							showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
							return true;
						} else return false;

					case 'listing':
						if (salesUser.indexOf(adminId) < 0 && demoListings.indexOf(restrictValue) > -1) {
							showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
							return true;
						} else return false;

					default:
						if (salesUser.indexOf(adminId) < 0) {
							showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
							return true;
						} else return false;
				}
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	};
}

export function demoRestrictionEncode() {
	return async (dispatch, getState, { client }) => {
		try {
			const settingData = await getConfigData({ name: ['isDemoRestricted'] });
			const adminId = getState()?.account?.privileges?.id;
			if (settingData?.isDemoRestricted == "true") {
				if (salesUser.indexOf(adminId) < 0) {
					return true;
				} else return false;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	};
}

export function userRestriction({ restrictType = null, restrictValue = null }) {
	return async (dispatch, getState, { client }) => {
		try {
			const settingData = await getConfigData({ name: ['isDemoRestricted'] });
			if (settingData?.isDemoRestricted == "true") {
				switch (restrictType) {
					case 'user':
						if (demoUser.includes(restrictValue)) {
							return true;
						} else return false;

					case 'profile':
						if (demoProfiles.includes(restrictValue)) {
							return true;
						} else return false;

					case 'listing':
						if (demoListings.includes(restrictValue)) {
							return true;
						} else return false;

					default: return false;
				}
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	};
}